

import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import atoms from "../../../atoms";
import { ISelectedRole, TAddStaffForm } from "../interface";

const { Input, IntlPhoneField, Select } = atoms;

const AddStaffForm = ({
    staff,
    _handleSearchUserID,
    handleChange,
    errors,
    staffEditID,
    rolesList,
    setCreateModal,
    createModal,
    showPassword,
    setShowPassword,
    handleSelectedRole
}: TAddStaffForm) => {
    return (
        <>
            <div className="row mt-4">
                <div className="col-md-4 mb-md-0 mb-3">
                    <div className="position-relative">
                        <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
                            User ID
                        </label>
                        <input
                            type="text"
                            className={"inputs form-control w-100"}
                            placeholder={"Enter User ID"}
                            value={staff.login_id}
                            onChange={(e: any) => _handleSearchUserID(e.target.value)}
                        />
                    </div>
                    {errors.login_id && (
                        <span className="error-text">{errors.login_id}</span>
                    )}
                </div>

                <div className="col-md-4 mb-md-0 mb-3">
                    <Input
                        label={"Staff Name"}
                        type={"text"}
                        placeholder={"Enter Person Name"}
                        errors={errors.username}
                        value={staff.username}
                        onChange={(e: any) => {
                            handleChange("username", e.target.value);
                        }}
                    />
                </div>

                <div className="col-md-4 mb-md-0 mb-3">
                    <IntlPhoneField
                        label={"Contact Number"}
                        placeholder={"Enter Contact Number"}
                        errors={errors.mobile}
                        value={staff.mobile}
                        onChange={(e: any) => {
                            handleChange("mobile", e);
                        }}
                    />
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-4 mb-md-0 mb-3">
                    <Input
                        label={"Email Address"}
                        type={"email"}
                        placeholder={"Enter Email Address"}
                        errors={errors.email}
                        value={staff.email}
                        onChange={(e: any) => {
                            handleChange("email", e.target.value);
                        }}
                    />
                </div>
                <div className="col-md-4 mb-md-0 mb-3 position-relative">
                    <div className="d-flex justify-content-between">
                        <label
                            className="inputs-label mb-2 fs-16 fw-600  secondary-color"
                            htmlFor="password"
                        >{`${staffEditID ? "" : "Enter"} Password`}</label>
                        {staffEditID && (
                            <a
                                className="fs-14"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setCreateModal(!createModal);
                                }}
                            >
                                Change Password
                            </a>
                        )}
                    </div>
                    <Input
                        type={`${showPassword ? "text" : "password"}`}
                        placeholder={"Enter Password"}
                        errors={errors.password}
                        value={staffEditID ? "********" : staff.password}
                        disabled={staffEditID && true}
                        onChange={(e: any) => {
                            handleChange("password", e.target.value);
                        }}
                    />
                    {!staffEditID && (
                        <span
                            className="position-absolute cursor-pointer"
                            style={{ top: "49%", right: "10%", fontSize: "20px" }}
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                        </span>
                    )}
                </div>
                <div className="col-md-4 mb-md-0 mb-3">
                    <Select
                        type={"text"}
                        className={"w-100"}
                        options={rolesList}
                        value={staff.role_id}
                        onChange={(e: ISelectedRole) => handleSelectedRole(e)}
                        placeholder={"Select"}
                        label={"Select Role"}
                        errors={errors?.role_id}
                    />
                </div>
            </div>
        </>
    );
};

export default AddStaffForm;
